import React, { useState } from "react";
import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  FormControl,
  Box,
} from "@mui/material";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Style from "./style";

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const schemaResolver = yupResolver(
    yup.object().shape({
      currentPassword: yup
        .string()
        .trim()
        .required("Please enter current Password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_+\-~()`{}[\]:;"'<>/?.,|\\]).{8,}$/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
      password: yup.lazy((_, schemaValues) =>
        schemaValues?.originalValue?.currentPassword
          ? yup
              .string()
              .required("Please enter New Password")
              .notOneOf(
                [yup.ref("currentPassword"), null],
                "New Password must be different from Old Password"
              )
              .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_+\-~()`{}[\]:;"'<>/?.,|\\]).{8,}$/,
                "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
              )
          : yup.string().trim().required("Please enter New Password")
      ),
      confirmPassword: yup
        .string()
        .trim()
        .required("Please Confirm New Password")
        .oneOf([yup.ref("password")], "Confirm New Password do not match"),
    })
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: schemaResolver,
    defaultValues: {
      currentPassword: "",
      password: "",
      confirmPassword: "",
    },
  });

  const onSubmit = async (values) => {
    console.log("val", values);
  };

  return (
    <Style.ChangePassword>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className="reset-password" display="grid" gap="16px">
          <FormControl fullWidth>
            <Typography variant="p">Current Password</Typography>
            <Controller
              name="currentPassword"
              control={control}
              defaultValue=""
              fullWidth
              render={({ field }) => (
                <TextField
                  placeholder="Enter your current password"
                  variant="outlined"
                  type={showPassword.currentPassword ? "text" : "password"}
                  fullWidth
                  size="small"
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" id="currentPassword">
                        <IconButton
                          className="custom-icon-button"
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              currentPassword: !showPassword.currentPassword,
                            })
                          }
                        >
                          {showPassword.currentPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.currentPassword}
                  helperText={errors.currentPassword?.message}
                  autoComplete="current-password"
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth>
            <Typography>New Password</Typography>
            <Controller
              name="password"
              control={control}
              defaultValue=""
              fullWidth
              render={({ field }) => (
                <TextField
                  placeholder="Enter your New password"
                  variant="outlined"
                  type={showPassword.newPassword ? "text" : "password"}
                  fullWidth
                  size="small"
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" id="password">
                        <IconButton
                          className="custom-icon-button"
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              newPassword: !showPassword.newPassword,
                            })
                          }
                        >
                          {showPassword.newPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  autoComplete="new-password"
                />
              )}
            />
          </FormControl>
          <FormControl fullWidth>
            <Typography variant="p">Confirm New Password</Typography>
            <Controller
              name="confirmPassword"
              control={control}
              defaultValue=""
              fullWidth
              render={({ field }) => (
                <TextField
                  placeholder="Confirm your new password"
                  variant="outlined"
                  size="small"
                  type={showPassword.confirmPassword ? "text" : "password"}
                  fullWidth
                  {...field}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="custom-icon-button"
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              confirmPassword: !showPassword.confirmPassword,
                            })
                          }
                        >
                          {showPassword.confirmPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword?.message}
                  autoComplete="new-password"
                />
              )}
            />
          </FormControl>
        </Box>
        <Button
          size="small"
          type="submit"
          variant="contained"
          color="primary"
          sx={{
            marginTop: "12px",
            textTransform: "none",
          }}
        >
          Update
        </Button>
      </form>
    </Style.ChangePassword>
  );
};

export default ChangePassword;
